import { replaceDistanceChar } from '../replace-distance-char';

export const getRoundDistance = (
  num: number,
): string => replaceDistanceChar(num.toFixed(1));
